<template>

  <div>
    <el-alert
      title="Bugün Sanal Pos İşlemi Yok"
      type="success"
      :closable="false"
      v-if="!data">
    </el-alert>
    <el-table
      class="table-xs"
      width="100%"
      :data="Liste"
      v-if="data"
      show-summary
      :summary-method="TableFooter"
      :height="Height">
      <el-table-column
        prop="Saat"
        label="Saat"
        width="50">
      </el-table-column>
      <el-table-column
        label="Makbuz No">
        <template slot-scope="scope">
          <a @click="MakbuzGetir(scope.row.mNo)">
            <span>{{ scope.row.mNo }}</span>
          </a>
        </template>
      </el-table-column>
      <el-table-column
        prop="Tutar"
        label="Tutar"
        align="right"
        width="100"
      >
      </el-table-column>
    </el-table>
    <MakbuzDetay v-if="MakbuzDetayModal" :mNo="mNo" @MakbuzDetayModal="MakbuzDetayModal=false"
                 :MakbuzDetayModal="MakbuzDetayModal"></MakbuzDetay>
  </div>

</template>

<script>
import MakbuzDetay from "../Vezne/MakbuzDetay";

export default {
  components: {MakbuzDetay},
  data() {
    return {
      Liste: null,
      mNo: null,
      data: false,
      MakbuzDetayModal: false,
      AltToplam: 0,
      Height: window.innerHeight - 370
    }
  },
  methods: {
    MakbuzGetir(mNo) {
      this.mNo = mNo;
      this.MakbuzDetayModal = true
    },
    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'panel/pos'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.AltToplam = response.AltToplam;
            this.lo = false;
            if (this.Liste) this.data = true;
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    TableFooter() {
      const sums = [];

      sums[2] = this.AltToplam;


      return sums;
    },
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelSanalPos.vue